/**
 * @file ClientDetailsTab.js
 * @description This file contains the ClientDetailsTab component, which displays and handles the details information of a client.
 */

import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fetchPopulationGroups } from "../../services/populationGroupService";
import Spinner from "../ui/spinners/Spinner";
import style from "./ClientList.module.scss";
import { ModalContext, ModalTypes } from "../../store/ModalContext";
import Toast from "../ui/toasts/Toast";
import styles from "./ClientList.module.scss";
import ClientDetailsForm from "./components/ClientDetailsForm";
import { ROUTES } from '../../constants/routes';
const ClientDetailsTab = ({ individualId, individualRecord, onSave }) => {
  const navigate = useNavigate();
  const [demographicData, setDemographicData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [populationGroups, setPopulationGroups] = useState([]);

  useEffect(() => {
    const loadPopulationGroups = async () => {
      try {
        const groups = await fetchPopulationGroups();
        const optionGroup = groups.map((group) => ({
          id: group.id,
          name: group.name,
        }));
        setPopulationGroups(optionGroup);
      } catch (error) {
        console.error("Could not fetch population groups", error);
      }
    };

    loadPopulationGroups();

    const fetchDemographicData = async () => {
      try {
        setDemographicData(individualRecord || {});
      } catch (error) {
        console.error("Error retrieving individual demographic data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (individualId) {
      fetchDemographicData();
    }
  }, [individualId]);

  const onReturnToList = () => {
    navigate(ROUTES.INDIVIDUALS);
  };

  const handleCancelClick = () => {
    onReturnToList();
  }

  return (
    <>
      {isLoading ? (
        <Spinner width={50} className={styles.loadingSpinner} />
      ) : (
        <>
          <div className={style.demographicTab}>
            <ClientDetailsForm
              individualId={individualId}
              initialData={demographicData}
              onSave={onSave}
              onCancel={handleCancelClick}
              populationGroups={populationGroups}
              isCreateMode={false}
            />
          </div>
        </>
      )}
    </>
  );
};

export default ClientDetailsTab;
